import { render, staticRenderFns } from "./DocVersionChip.vue?vue&type=template&id=31ed4ec7"
import script from "./DocVersionChip.vue?vue&type=script&lang=js"
export * from "./DocVersionChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports